import { render } from "./ProjectItem.vue?vue&type=template&id=1f3e93f3"
import script from "./ProjectItem.vue?vue&type=script&lang=js"
export * from "./ProjectItem.vue?vue&type=script&lang=js"
script.render = render

export default script